// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"e250fa51","732":"5b3929d4","977":"475ff47f"}[chunkId] + ".chunk.js";
};